import React from 'react';

import type { IconProps } from '@atlaskit/icon';
import SVG from '@atlaskit/icon/svg';
import { token } from '@atlaskit/tokens';

type SharpCornerGlyphProps = {
	color?: string;
};

export const SharpCornerIcon = (props: IconProps & SharpCornerGlyphProps) => {
	return (
		<SVG primaryColor={props.color ?? token('color.text')} size="small" {...props}>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.25 2H7.5V4.25H2.25V9.5H0V4.25 2H2.25ZM0 15.5V20.75 23H2.25 7.5V20.75H2.25V15.5H0ZM18.75 15.5V20.75H13.5V23H18.75 21V20.75 15.5H18.75ZM21 9.5V4.25 2H18.75 13.5V4.25H18.75V9.5H21Z"
			/>
		</SVG>
	);
};
